import Token from '@/di/di.token'

import useService from './useService'

export default function useActivityGroupService() {
  const { service } = useService(Token.ACTIVITY_GROUP_SERVICE)
  return { service }
}
